const start = {
  slug: 'start',
  title: 'Geef je mening over het energieneutrale Pajottenland van de toekomst en bouw zelf je ideal energielandschap.',
  body: 'Wist je dat we in het Pajottenland allemaal samen jaarlijks maar liefst meer dan 2,6 miljoen MWh aan energie verbruiken? Die energie bestaat hoofdzakelijk uit elektriciteit van kerncentrales en fossiele brandstoffen, zoals benzine, diesel, stookolie en aardgas.<br/><br/>Tegen 2040 willen we een energieneutraal Pajottenland: alle energie die dan nog verbruikt wordt, wordt in het Pajottenland zelf geproduceerd uit hernieuwbare energiebronnen. <span data-tippy-content="Momenteel verbruiken we vooral fossiele brandstoffen en kernenergie. Fossiele brandstoffen zullen op een dag echter opgebruikt zijn. Bij de verbranding ervan komen ook broeikasgassen en schadelijke stoffen vrij. Het gebruik van kernenergie brengt dan weer veel veiligheidsrisico’s en hoge kosten met zich mee.<br/><br/>Hernieuwbare energie daarentegen is overvloedig beschikbaar. Zo levert de zon op één uur tijd evenveel energie als de mens momenteel op een heel jaar verbruikt. Verschillende technieken om hernieuwbare energie te produceren, zoals zonnepanelen en windturbines, kunnen goed toegepast worden in België en zijn op termijn zelfs goedkoper dan kernenergie of fossiele brandstoffen.">Hernieuwbaar</span> en <span data-tippy-content="Waarom zouden we moeten overschakelen op hernieuwbare energie? En waarom zou die dan lokaal - in het Pajottenland - geproduceerd moeten worden? Windparken op zee storen alleen de vissen en in de woestijn schijnt de zon elke dag…<br/><br/>Ingevoerde hernieuwbare energie is dus goed, maar lokaal geproduceerde hernieuwbare energie is nog beter. Omdat er vaak weinig of geen tussenhandel is, gaan de opbrengsten rechtstreeks naar de producent. Dankzij lokale burgercoöperaties krijgen alle Pajotten de kans om mee te investeren in eigen hernieuwbare energie.">lokaal</span> dus!',
  controls: false,
  backgroundImage: 'pajottenland_cover.jpg',
  cameraPosition: [0, 0, 0],
  cameraRotation: [0, 0, 0],
  layers: ['base'],
};

const huishoudens = {
  slug: 'huishoudens',
  title: '',
  body:
    'De Pajotse huishoudens verbruiken samen <strong>meer dan een derde</strong> van het totale energieverbruik van de regio. Deze energie gaat naar de verwarming van woningen en sanitair warm water, en naar het elektriciteitsverbruik in woningen.',
  cameraPosition: [241.76695007641905, 10.988150056689857, 317.1866311875923],
  cameraRotation: [-0.05144302763925776, -0.059736764487583145, -0.0030739150647756033],
  layers: ['base', 'huis_doorsnede'],
};

const transport = {
  slug: 'transport',
  title: '',
  body:
    'Ook onze verplaatsingen verbruiken vandaag meer dan een derde van alle energie die in het Pajottenland aangewend wordt. Het gaat dan over de <span data-tippy-content="Verplaatsingen over snelwegen, spoorwegen of water zijn hierin niet meegerekend, omdat het dan heel vaak gaat over verplaatsingen die niet lokaal zijn.">kilometers</span> die we afleggen met de wagen en het openbaar vervoer om ons te verplaatsen in het Pajottenland, maar ook over de kilometers die goederen afleggen om op hun bestemming te komen.',
  cameraPosition: [90.73274630271955, 18.131070714732672, 118.0396857105356],
  cameraRotation: [-1.7314246201126333, -1.3597017302124073, -1.735006671745281],
  layers: ['base'],
};

const bedrijvigheid = {
  slug: 'bedrijvigheid',
  title: '',
  body:
    'De bedrijven in het Pajottenland zijn samen goed voor een derde van het Pajotse energieverbruik. Deze energie gaat vooral naar de dienstensector (14%) en industrie (10%), gevolgd door de landbouw (3%).',
  cameraPosition: [2.334801618087198, 29.373075477360125, 100.49652595414872],
  cameraRotation: [-2.098291550984853, -1.2051844349427043, -2.1285224101999907],
  layers: ['base'],
};

const klimaatneutraal = {
  slug: 'klimaatneutraal',
  title: 'Probeer nu zelf het verbruik energieneutraal te maken',
  body:
    'Ons huidige energieverbruik volledig opvangen met hernieuwbare energie lukt dus niet. De maximale hoeveelheid hernieuwbare energie die we in de toekomst zouden kunnen produceren in het Pajottenland dekt maar de helft van ons huidig jaarlijks verbruik. Met de hoeveelheid energie die we vandaag verbruiken in het Pajottenland kunnen we dus niet energieneutraal worden. Vandaag wordt slechts 3% van de Pajotse energievraag opgevangen door hernieuwbare energie.',
  cameraPosition: [21.46769986564857, 29.08156010765319, 248.0369259538552],
  cameraRotation: [-0.33176477569322554, -1.2141940304802128, -0.31226338847606233],
  controls: ['samen'],
  resetControls: true,
  metrics: true,
  goal: 2628668,
  nonGoal: 0,
  goalText: 'het huidige verbruik (2.628.668 MWh)',
  layers: ['base'],
};

const verlagen = {
  slug: 'verlagen',
  title: 'Ons energieverbruik moet dalen',
  body:
    'Als we allemaal samen minder maar vooral slimmer energie gebruiken, dan kunnen we in het Pajottenland ons toekomstig energieverbruik verminderen tot ongeveer een derde van ons huidig verbruik <span data-tippy-content="Hoeveel we in de toekomst zullen besparen, is afhankelijk van de mate waarin gezinnen en bedrijven zullen worden aangezet tot een meer rationeel energieverbruik.<br/><br/>We gaan er ook van uit dat we meer en meer gebruik gaan maken van elektriciteit. Zo zullen we voor onze verplaatsingen meer en meer elektrische fietsen en wagens gaan gebruiken, en voor onze verwarming inzetten op warmtepompen en warmtenetten. Het voordeel hiervan is dat elektrische toestellen efficiënter zijn in hun energieverbruik dan toestellen op fossiele brandstoffen. Een elektrische wagen verbruikt bijvoorbeeld minder ‘energie’ dan een wagen op diesel of benzine om hetzelfde aantal kilometers te rijden.">energiebesparing</span> is de sleutel tot succes!<br/><br/>Dit doe je door je woning beter te isoleren, je mobiliteitskeuzes aan te passen, te consuminderen (energiebesparing), door over te schakelen op - steeds zuinigere - elektrische toestellen die minder energie verbruiken dan toestellen op fossiele brandstoffen (energie-efficiëntie).',
  cameraPosition: [332.2415724811742, 60.714155219872445, 342.2761340655928],
  cameraRotation: [-0.6156417967061716, 0.5233286312226337, 0.33979786998405537],
  resetControls: true,
  metrics: true,
  goal: 899479,
  nonGoal: 1729189,
  goalText: 'het toekomstige verbruik (899.479 MWh)',
  layers: ['base'],
};

const energieMix = {
  slug: 'energieMix',
  title: 'Wat zijn de bronnen van hernieuwbare energie?',
  body:
    'Om energieneutraal te worden in het Pajottenland kunnen we  gebruik maken van zon, wind en biomassa zoals hout en mest. Er zijn voldoende van deze <span data-tippy-content="Het gebruik van omgevingswarmte kan niet zonder elektriciteit, en waterkracht levert maar een fractie van de nodige energie op. Deze twee energiebronnen nemen we dus niet verder mee.<br/><br/>Kernenergie heeft geen CO2-uitstoot, maar ze is niet hernieuwbaar. Het is een technologie die veel veiligheidsrisico’s inhoudt. Bovendien moet voor de berging van nucleair afval met honderden jaren gerekend worden en zijn er hoge kosten verbonden aan de ontwikkeling en het onderhoud van kernenergiecentrales.">energiebronnen</span> in het Pajottenland aanwezig.',
  cameraPosition: [428.41226334963153, 105.45442410848588, 281.7101370315346],
  cameraRotation: [-1.0389133839224227, 0.7968646746393298, 0.8822993987694527],
  metrics: true,
  goal: 899479,
  nonGoal: 1729189,
  goalText: 'het toekomstige verbruik (899.479 MWh)',
  layers: ['base'],
};

const zonneEnergie = {
  slug: 'zonneEnergie',
  title: 'Voeg zonne-energie toe',
  body:
    'Zonne-energie is wellicht de belangrijkste bron van hernieuwbare energie: ze is vrijwel onuitputtelijk en overal toepasbaar. De meest gekende manier om zonne-energie te oogsten zijn de <span data-tippy-content="Naast de snelle en eenvoudige plaatsing, heeft een PV-installatie ook als voordeel dat de kostprijs de afgelopen jaren fors gedaald is. De technische evolutie gaat heel erg snel, waardoor het rendement in de toekomst zeker en vast nog zal stijgen.<br/><br/>  Wie in Vlaanderen nieuwe zonnepanelen installeert, moet een recyclagebijdrage betalen. Dat geld komt terecht in een fonds dat wordt gebruikt voor de kosteloze inzameling en recyclage van afgedankte zonnepanelen. Zonnepanelen bevatten immers veel kostbare materialen die perfect te recycleren zijn.">zonnepanelen</span> met fotovoltaïsche cellen, ook wel een PV-installatie genoemd. Deze panelen zetten het zonlicht om in elektriciteit. Door de panelen op bestaande daken te installeren, nemen ze geen nieuwe ruimte in. Zonnepanelen kunnen ook op het water of op land geïnstalleerd worden.<br/><br/>Voeg zonne-energie toe en zie welke impact dit op het landschap heeft.',
  cameraPosition: [253.81658576102075, 29.67165133947369, 359.3701451845772],
  cameraRotation: [-0.18407318976197554, 0.023539016831844978, 0.0043820787870679995],
  controls: ['zon'],
  resetControls: true,
  metrics: true,
  goal: 899479,
  nonGoal: 1729189,
  goalText: 'het toekomstige verbruik (899.479 MWh)',
  layers: ['base'],
};

const windenergie = {
  slug: 'windenergie',
  title: 'Voeg windenergie toe',
  body:
    'Wind wordt omgezet in elektriciteit met behulp van windturbines. De kleinschalige windturbines, die kleiner zijn dan 15m, zijn niet rendabel in het Pajotse landschap. We onderzochten voor het Pajottenland dan ook de mogelijkheden voor de <span data-tippy-content="Een <strong>middenschalige windturbine</strong> is makkelijker inpasbaar in het Pajotse landschap dankzij het afwisselende reliëf en is door de beperkte hoogte sneller uit het zicht in vergelijking met een grootschalige windturbine. Een middenschalige windturbine levert op jaarbasis 75 MWh. Dit is goed voor het verbruik van 1,3 huishoudens vandaag.">middenschalige windturbines</span> van 50m hoog en de <span data-tippy-content="Hoe hoger de windturbine, des te meer wind hij vangt. Het rendement van een <strong>grootschalige windturbine</strong> is daardoor ook exponentieel hoger dan een middenschalige windturbine. De jaarlijkse productie van 1 grootschalige windturbine is hetzelfde als die van 60 middenschalige windturbines. Een grootschalige windturbine van 120m hoog levert namelijk op jaarbasis 4500 MWh, goed voor het verbruik van 76,3 huishoudens vandaag. Maar zoals eerder al vermeld, zal ons energieverbruik in de toekomst dalen, zodat de opgewekte energie van één windturbine nog meer verbruikers zal bedienen.">grootschalige windturbines</span> van 120m tot 200m hoog. Jaarlijks produceert één grootschalige windturbine evenveel energie als 60 middenschalige windturbines.<br/><br/>Voeg windenergie toe en zie welke impact dit op het landschap heeft.',
  cameraPosition: [-30.2179046905680195, 119.08232432940913, 360.8959336236014],
  cameraRotation: [-0.45255011633999415, -0.6513312368939116, -0.2866417477422288],
  controls: ['wind'],
  resetControls: true,
  metrics: true,
  goal: 899479,
  nonGoal: 1729189,
  goalText: 'het toekomstige verbruik (899.479 MWh)',
  layers: ['base'],
};

const biomassa = {
  slug: 'biomassa',
  title: 'Voeg biomassa toe',
  body:
    'Niet alleen zon en wind zijn een bron van energie. Ook het landschap zelf produceert grondstoffen voor het opwekken van hernieuwbare energie. Dan kijken we naar de mogelijkheden om energie te winnen uit biomassa. We hebben houtige biomassa, zoals snoeiafval van hagen en heggen, die we via <span data-tippy-content="Door middel van verbranding produceert een hoogrenderende <strong>biomassaverbrander</strong> groene warmte uit houtige biomassa. Deze installatie wordt vaak gebruikt in grotere gebouwen die niet voldoende geïsoleerd kunnen worden. Zo volstaat het snoeihout van 150 lopende meter houtkant om een woning een jaar lang te verwarmen. Technologische innovaties, een goede afstelling en zorgvuldig onderhoud van de verbrander zorgen ervoor dat de uitstoot van fijn stof en schadelijke gassen onder de norm blijft.">biomassaverbranding</span> omzetten in duurzame warmte, en een <span data-tippy-content="Een <strong>pocketvergister</strong> is een andere technologie die bijvoorbeeld inzetbaar is bij veeteeltbedrijven vanaf 80 runderen. De vergister zet de rundermest om in duurzame warmte en/of biogas. Op jaarbasis kan een pocketvergister 75 MW energie produceren uit mest. Dit is voldoende om vandaag 1,3 huishoudens van elektriciteit te voorzien.">pocketvergister</span> kan de mest van runderen omzetten in biogas.<br/><br/>Voeg biomassa toe en zie welke impact dit op het landschap heeft.',
  cameraPosition: [348.15072290175806, 163.3378691804297, 396.11965834123265],
  cameraRotation: [-0.766033164991819, 0.26569778078567147, 0.2474287112538904],
  controls: ['biomassa'],
  resetControls: true,
  metrics: true,
  goal: 899479,
  nonGoal: 1729189,
  goalText: 'het toekomstige verbruik (899.479 MWh)',
  layers: ['base'],
};

const idealeMix = {
  slug: 'idealeMix',
  title: 'Stel nu je ideale energiemix samen',
  body:
    'Met één specifieke bron van hernieuwbare energie alleen komen we er dus niet. Wat is jouw ideale hernieuwbare energielandschap voor het Pajottenland? Welke energiebronnen zou jij inzetten om het Pajottenland energieneutraal te maken tegen het jaar 2040?<br/><br/>Geef ons jouw ideale energiemix door.',
  cameraPosition: [190.17285553374515, 80.42108612173419, 399.0419261849081],
  cameraRotation: [-0.4217765371027527, -0.009898772032334193, -0.004441527425907628],
  controls: ['zon', 'wind', 'biomassa'],
  resetControls: true,
  metrics: true,
  goal: 899479,
  nonGoal: 1729189,
  goalText: 'het toekomstige verbruik (899.479 MWh)',
  layers: ['base'],
};

const share = {
  slug: 'share',
  title: 'Bedankt!',
  body:
    'We hebben je antwoord goed ontvangen! Wij leggen je antwoord samen met de andere ingezonden energiemixen voor aan de bevoegde beleidsmakers in het Pajottenland. Zo werk je mee aan een energieneutrale toekomst voor het Pajottenland. {{ rankedResults }} Deel je eigen mix op sociale media:',
  cameraPosition: [225.83091506580183, 33.563433946887976, 357.06599637451353],
  cameraRotation: [-0.32551398790508645, -0.3780954634881847, -0.12395715067645398],
  socialMedia: true,
  metrics: false,
  goal: 899479,
  nonGoal: 1729189,
  goalText: 'het toekomstige verbruik (899.479 MWh)',
  layers: ['base'],
};

const sequence = {
  name: 'Opgewekt Pajottenland',
  db: 'pajottenland',
  scenes: [
    start,
    huishoudens,
    transport,
    bedrijvigheid,
    klimaatneutraal,
    verlagen,
    energieMix,
    zonneEnergie,
    windenergie,
    biomassa,
    idealeMix,
    share,
  ],
  layerMap: {},
};

export default sequence;
